import ReactDOM from 'react-dom/client';
import Main from './Main.js';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<Main />);
